export default class EventBus {
    constructor() {
        this.handlers = {}
    }

    on(name, handler) {
        const list = this.handlers[name] || (this.handlers[name] = [])
        list.push(handler)
    }

    off(name, handler) {
        const list = this.handlers[name]

        if (list) {
            const index = list.indexOf(handler)

            if (index !== -1) {
                list.splice(index, 1)
            }
        }
    }

    fire(name, payload) {
        if (this.handlers[name]) {
            this.handlers[name].forEach(handler => handler(payload))
        }
    }
}